// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".js?" + {"436":"37994112b4","636":"886a85a76c"}[chunkId] + "";
};